import * as HackleSDK from '@hackler/javascript-sdk';
import { PropertyOperationsBuilder } from '@hackler/javascript-sdk';

let Hackle = {};

Hackle.install = function (Vue) {
  const hackleConfig = {
    debug: process.env.NODE_ENV === 'development',
  };

  const hackleClient = HackleSDK.createInstance(process.env.VUE_APP_HACKLE_SDK_KEY, hackleConfig);

  // GTM 호환을 위해 window에 저장
  window.hackleClient = hackleClient;

  hackleClient.onReady(() => {
    console.log('Hackle SDK ready');
  });

  /**
   * A/B 테스트 그룹 할당
   * @param {string} experimentKey - 실험 키
   * @returns {string} 할당된 그룹
   */
  const getVariation = experimentKey => {
    return new Promise((resolve, reject) => {
      try {
        // A/A 테스트 그룹 할당

        hackleClient.onReady(() => {
          const variation = hackleClient.variation(experimentKey);

          console.log('the Users Variation is', variation);

          resolve(variation);
        });
      } catch (error) {
        console.error('A/A Test Error:', error);
        reject(error);
      }
    });
  };

  const trackEvent = (key, properties) => {
    hackleClient.track({ key, properties });
  };

  const updateHackleCommonProperties = user => {
    hackleClient.setUserId(user?.companyId);

    const operations = new PropertyOperationsBuilder()
      .set('clientAccessTime', new Date().toISOString())
      .set('createdAt', user.createdAt)
      .set('agreeToMarketing', user.agree_to_mail)
      .set('isMember', true)
      .build();

    hackleClient.updateUserProperties(operations);
  };

  const resetHackleCommonProperties = () => {
    hackleClient.setUserId(undefined);
    hackleClient.updateUserProperties(new PropertyOperationsBuilder().clearAll().build());
  };

  Vue.prototype.$hackle = hackleClient;
  Vue.prototype.$getVariation = getVariation;
  Vue.prototype.trackHackleEvent = trackEvent;
  Vue.prototype.updateHackleCommonProperties = updateHackleCommonProperties;
  Vue.prototype.resetHackleCommonProperties = resetHackleCommonProperties;
};

export default Hackle;
